import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  TopToolbar,
  ListButton,
  required,
  BooleanInput,
  SelectInput,
} from "react-admin";

import { tagOptions } from "./Tag";

const AddressTitle = ({ record }) => {
  return <span>Address: {record ? `${record.address}` : ""}</span>;
};

const EditActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} label="Back" />
  </TopToolbar>
);

const LabelEdit = (props) => (
  <Edit title={<AddressTitle />} actions={<EditActions />} {...props}>
    <SimpleForm>
      <TextInput disabled source="id" label="Label Id" variant="outlined" />
      <TextInput source="address" validate={[required()]} variant="outlined" />
      <TextInput source="label" validate={[required()]} variant="outlined" />
      <SelectInput
        source="tag"
        validate={[required()]}
        choices={tagOptions}
        variant="outlined"
      />
      <TextInput source="website" variant="outlined" />
      <TextInput source="twitter" variant="outlined" />
      <TextInput source="blog" variant="outlined" />
      <TextInput source="telegram" variant="outlined" />
      <TextInput source="discord" variant="outlined" />
      <TextInput source="keybase" variant="outlined" />
      <BooleanInput source="status" label="Status" variant="outlined" />
    </SimpleForm>
  </Edit>
);

export default LabelEdit;
